import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonCard} from '@ionic/react';
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import axiosInstance from '../services/AxiosInstance';
import {CircularProgressbarWithChildren, buildStyles} from 'react-circular-progressbar';
import Chart from 'chart.js/auto';
import './css/general.css';
import styles from './css/MoodOverview.module.css';

interface MoodOverviewProps extends RouteComponentProps {
    // Define the props here
  }
  interface MoodOverviewState {
    // Define the state here
    moods: string[],
    mostEmoji: string[],
    leastEmoji: string[],
    top3emojis: string[],
    bottom3emojis: string[],

    averageMoodScore: number,

    countEmojis: CountEmojis[],
    moodPerSubject: MoodPerSubject[],
    firstChallengeScore: number,
    lastChallengeScore: number,

    level:number
  }

  interface CountEmojisInterface{
    emoji: string,
    count: number,
    percentage: number
}


class CountEmojis implements CountEmojisInterface {
  emoji: string;
  count: number;
  percentage: number

    constructor(emoji: string, count: number, percentage: number) {
      this.emoji = emoji;
      this.count = count;
      this.percentage = percentage
    }
}


  interface MoodPerSubjectInterface{
    id: number,
    name: string,
    moodScore: number,
    moodColor: string,
    emoji: string
}


class MoodPerSubject implements MoodPerSubjectInterface {
  id: number;
  name: string;
  moodScore: number;
  moodColor: string;
  emoji: string

    constructor(id: number, name: string, moodScore: number, moodColor: string, emoji: string) {
      this.id = id;
      this.name = name;
      this.moodScore = moodScore;
      this.moodColor = moodColor;
      this.emoji = emoji
    }
}

  class MoodOverviewAll extends React.Component<MoodOverviewProps, MoodOverviewState>{
    chartRef = React.createRef<HTMLCanvasElement>();
    private barChart: Chart | null = null;
    private lineChart: Chart | null = null;

    constructor(props: MoodOverviewProps) {
      super(props);
  
      this.state = {
        moods: [],
        mostEmoji: [],
        leastEmoji: [],
        top3emojis: [],
        bottom3emojis: [],

        averageMoodScore: 0,

        countEmojis: [
          {
            emoji: "",
            count: 0,
            percentage:0
          }
        ],

        moodPerSubject: [
          {
            id: 0,
            name: "",
            moodScore: 0,
            moodColor:"",
            emoji: ""
          }
        ],

        firstChallengeScore: 0,
        lastChallengeScore: 0,

        level: 0
    }

    this.getLevel()
  }

  async getLevel(){
    var id = localStorage.getItem("id");
    var token = localStorage.getItem("token");

    let challengesDone: number = 0

  axiosInstance
  .get(
      "/Results/Employee/" + id,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    )
  .then((res) => {
      res.data.forEach((quiz: any) => {
        if(quiz.score >= 0) {
          challengesDone ++
        }
    });
    let level:number = 1
    let challengesForNextLevel:number[] = [3,4,3,2]
    let challengesToDo = challengesForNextLevel[0]
    let index: number = 0
    
    while(challengesDone >= challengesToDo) {
       challengesDone -= challengesToDo;
       level ++;
       if(index % 2 == 0) {
           challengesForNextLevel.push(3)
       } else {
           challengesForNextLevel.push(2)
       }
       index ++
       challengesToDo = challengesForNextLevel[index]
    }

    this.setState({level: level})
    })

    this.getMoods()
  }

  calculateMoodScore(mood: string, score: number){
    switch(mood) {
      case "InLove":
        score += 100;
        break;
      
      case "Easy":
        score += 90;
        break;
      
      case "Funny":
        score += 80;
        break;
      
      case "Good":
        score += 70;
        break;
      
      case "OK":
        score += 60;
        break;
      
      case "Neutral":
        score += 50;
        break;
      
      case "Surprised":
        score += 40;
        break;
      
      case "Angry":
        score += 30;
        break;
      
      case "Sad":
        score += 20;
        break;
      
      case "VerySad":
        score += 10;
        break;
      
      case "Sick":
        score += 0;
        break;
      
      default:
        score += 50;
        break
    }
    return score
  }

  async getMoods() {
      var id = localStorage.getItem("id");
      var token = localStorage.getItem("token");

    axiosInstance
      .get(
        "/Moods/user/" + id,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )

      .then((response) => {
        //console.log(response.data)
        response.data.forEach((mood: any) => {
            this.state.moods.push(mood.employeeMood)
        });
        //console.log(this.state.moods)
        this.setState({ moods: this.state.moods });
        this.getMoodScore()
    });
              
  };

  async getMoodScore(){
    let score = 0;
    this.state.moods.forEach((mood) => {
      score = this.calculateMoodScore(mood, score)
    })
      let averageMoodScore = Math.round(score / this.state.moods.length)
      this.setState({averageMoodScore: averageMoodScore})

    if(this.state.level >= 5) {
      this.getMostAndLeastUsedEmoji()
    }
  }

  async getMostAndLeastUsedEmoji(){
    // https://www.jsowl.com/count-duplicate-values-in-an-array-in-javascript/#:~:text=To%20count%20the%20duplicate%20values,the%20count%20during%20each%20iteration.
    const elementCounts: { [mood: string]: number } = {};
    this.state.moods.forEach(mood => {
        elementCounts[mood] = (elementCounts[mood] || 0) + 1;
    });
    //console.log(elementCounts);

    let values = Object.values(elementCounts);
    let max = Math.max(...values);
    let min = Math.min(...values);
    //console.log(max);
    //console.log(min);
    
    
    let keys = Object.keys(elementCounts);
    let maxEmojis = keys.filter(key => elementCounts[key] === max);
    let minEmojis = keys.filter(key => elementCounts[key] === min);
    // console.log(maxEmojis);
    // console.log(minEmojis);

    // for graphData
    values.forEach((element: any, index: number) => {
      this.state.countEmojis.push({
        emoji: keys[index],
        count: values[index],
        percentage: Math.round((values[index] / this.state.moods.length) * 100)
      })
    })
    this.state.countEmojis.splice(0,1)
    //console.log(this.state.countEmojis);
    
    this.setState({mostEmoji: maxEmojis, leastEmoji: minEmojis, countEmojis: this.state.countEmojis})
    
    if(this.state.level >= 6) {
      this.getOtherEmojis()
    }  
  }

  async getOtherEmojis() {
    let topEmojis = [...this.state.countEmojis].sort((a,b) => b.count - a.count)
    //console.log(topEmojis)

    let bottomEmojis = [...this.state.countEmojis].sort((a,b) => a.count - b.count)
    //console.log(bottomEmojis)

    let top3 = topEmojis.splice(0, 3)
    //console.log(top3)
    
    let bottom3 = bottomEmojis.splice(0,3)
    //console.log(bottom3)

    for(let i in top3){
      this.state.top3emojis.push(top3[i].emoji)
    }
    //console.log(this.state.top3emojis)

    for(let i in bottom3){
      this.state.bottom3emojis.push(bottom3[i].emoji)
    }
    //console.log(this.state.bottom3emojis)

    this.setState({top3emojis: this.state.top3emojis, bottom3emojis: this.state.bottom3emojis})

    if(this.state.level >= 7){
      this.getDetailOverviewData()
    }
  }
  
  getDetailOverviewData(){
    
    let allMoods = ["InLove", "Easy", "Funny", "Good", "OK", "Neutral", "Surprised", "Angry", "Sad", "VerySad", "Sick"]

    let selected: string[] = []
      this.state.countEmojis.forEach((e) => {
        selected.push(e.emoji)
      })

    // check which emoji not selected yet
    allMoods.forEach((mood) => {
      if(!selected.includes(mood)) {
        this.state.countEmojis.push({
          emoji: mood,
          count: 0,
          percentage: 0
        })
      }
    })
    this.setState({countEmojis: this.state.countEmojis})

    // Change emoji names into emoticons + sort this.state.countEmojis
    let graphData: any[] = []
    let emoticon: string = ""
    let placeInGraph: number = 0
    
    this.state.countEmojis.forEach((mood) => {
      switch(mood.emoji) {
        case "InLove":
          emoticon = "🥰️"
          placeInGraph = 11
          break;
        
        case "Easy":
          emoticon = "😎"
          placeInGraph = 10
          break;
        
        case "Funny":
          emoticon = "🤣"
          placeInGraph = 9
          break;
        
        case "Good":
          emoticon = "😃"
          placeInGraph = 8
          break;
        
        case "OK":
          emoticon = "🙂"
          placeInGraph = 7
          break;
        
        case "Neutral":
          emoticon = "😐"
          placeInGraph = 6
          break;
        
        case "Surprised":
          emoticon = "😮"
          placeInGraph = 5
          break;
        
        case "Angry":
          emoticon = "😤"
          placeInGraph = 4
          break;
        
        case "Sad":
          emoticon = "😢"
          placeInGraph = 3
          break;
        
        case "VerySad":
          emoticon = "😭"
          placeInGraph = 2
          break;
        
        case "Sick":
          emoticon = "🤮"
          placeInGraph = 1
          break;
      }
      graphData.push({
        label: emoticon,
        data: mood.percentage,
        place: placeInGraph
      })
    })
    graphData.sort((a, b) => a.place - b.place);

    this.getDetailOverview(graphData)
    
  }

  async getDetailOverview(data: any[]){
    if(this.state.level >= 8){
      this.getAllSubjects()
    }

    const canvas =  document.getElementById("barChartMoods") as HTMLCanvasElement;
    if(!canvas) return;
  
    const context = canvas.getContext("2d");
    if(!context) return;

    if (this.barChart) {
      this.barChart.destroy();
    }
    
    // Set font family for all charts
    Chart.defaults.font.family = "Comfortaa_400Regular"

    // Set fontSize based on screen width
    let screenWidth = window.innerWidth
    let labelSize: number  = 12
    let legendSize: number  = 12

    if(screenWidth >= 600 && screenWidth < 1000) {
      labelSize  = 25
      legendSize  = 18
    } else if(screenWidth >= 1000) {
      labelSize  = 30
      legendSize  = 20
    } else{
      labelSize  = 15
    }


    this.barChart = new Chart(context, {
      type: "bar",
      data: {
        labels: data.map((e) => e.label),
        datasets: [
          {
            label: "Aantal keer geselecteerd (in %)",
            data: data.map((e) => e.data),
          },
        ],
      },
      options: {
        scales: {
          x:{
            ticks: {
              font:{
                size: labelSize
              }
            },
          },
          y: {
            beginAtZero: true,
            max:100,
          }
        },

        plugins: {
          legend: {
            labels: {
              font: {
                size: legendSize,
              }
            }
          }
        }
      },
    });
  }

  async getAllSubjects(){
    const token = localStorage.getItem("token");
    var id = localStorage.getItem("id");
    const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  let subjects: any[] = []
      
    axiosInstance
      .get("/UserSubjects/" + id, config)
      .then((resp) => {
        //console.log(resp.data)
        resp.data.forEach((subject: any) => {
          //console.log(subject.subject)
          subjects.push({
            subjectId: subject.subject.id,
            subjectName: subject.subject.subjectName
          })
        })
        this.getMoodScorePerSubject(subjects)
      })
  }

  async getMoodScorePerSubject(subjects: any[]){
    const token = localStorage.getItem("token");
    var id = localStorage.getItem("id");
    const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

        subjects.forEach((sub) => {
          let score: number = 0
          axiosInstance.get("/Moods/subject/" + sub.subjectId + "/user/" + id,config)
          .then((res) => {
            //console.log(res.data)
            res.data.forEach((mood: any) => {
                score = this.calculateMoodScore(mood.employeeMood, score)
            })
            let average = Math.round(score / res.data.length)
            let color;
            let emoji;

            //console.log(`Average ${sub.subjectName} : ${average}`)

            // mood color
            if(average < 50) {
              color = "#FF0000"
            } else if (average > 50) {
              color = "#2dd36f"
            } else {
              color = "#FFA500"
            }
            
            // general emoji
            if(average <= 30) {
              emoji = "Sad"
            } else if (average > 30 && average < 50) {
              emoji = "Surprised"
            } else if(average == 50){
              emoji = "Neutral"
            } else if(average > 50 && average <= 70){
              emoji = "OK"
            } else if(average > 70 && average < 90){
              emoji = "Good"
            } else if(average >= 90){
              emoji = "InLove"
            } else{
              emoji = "Neutral"
            }
            this.state.moodPerSubject.push({
              id: sub.subjectId,
              name: sub.subjectName,
              moodScore: average,
              moodColor: color,
              emoji: emoji
            })
            //console.log(this.state.moodPerSubject)
            this.state.moodPerSubject.sort((a,b) => a.id - b.id)
            this.setState({moodPerSubject: this.state.moodPerSubject})

            if(this.state.level >= 9){
              this.getEvolutionGraphData()
            }
          })
        })
  }

  async getEvolutionGraphData() {
    const token = localStorage.getItem("token");
    var id = localStorage.getItem("id");
    const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };


    let challenges = localStorage.getItem("challengeList")
    if(challenges) {
      let challengeList = JSON.parse(challenges)
      //console.log(challengeList)
     let completedChallenges = challengeList.filter((challenge: any) => challenge.challengeScore != -1)
     completedChallenges.sort((a:any, b:any) => a.challengeId - b.challengeId)
     //console.log(completedChallenges)

     let graphData: any[] = []
     
     
     axiosInstance
     .get("/Moods/user/" + id, config)
     .then((res) => {
       completedChallenges.forEach((challenge: any) => {
        let score: number = 0
        let average: number = 0

         res.data.forEach((mood: any) => {
           if(mood.challengeId == challenge.challengeId) {
             score = this.calculateMoodScore(mood.employeeMood, score)
             average = Math.round(score/3)
           }
         })
           graphData.push({
             label: challenge.challengeTitle,
             data: average,
           })
       })
        //console.log(graphData)
        this.setState({firstChallengeScore: graphData[0].data, lastChallengeScore: graphData[graphData.length -1].data})

        this.getEvolutionChart(graphData)
     })
     
    }
  }

  async getEvolutionChart(data: any[]){
    const canvas =  document.getElementById("evolutionChart") as HTMLCanvasElement;
    if(!canvas) return;
  
    const context = canvas.getContext("2d");
    if(!context) return;

    if (this.lineChart) {
      this.lineChart.destroy();
    }


    this.lineChart = new Chart(context, {
      type: "line",
      data: {
        labels: data.map((e) => e.label),
        datasets: [
          {
            label: "Gemiddelde mood score per challenge (in %)",
            data: data.map((e) => e.data),
          },
        ],
      },
      options: {
        scales: {
          x: {
            ticks:{
              autoSkip: false
            }
          },
          y: {
            beginAtZero: true,
            max:100,
            ticks:{
              autoSkip: false
            }
          }
        },
      },
    });
  }


    render(){
      
      let level4;
      let moodScoreColor;
        if(this.state.averageMoodScore < 50) {
          moodScoreColor = "#FF0000"
        } else if (this.state.averageMoodScore > 50) {
          moodScoreColor = "#2dd36f"
        } else {
          moodScoreColor = "#FFA500"
        }
  
        let generalMood;
        let quotes;
        
        if(this.state.averageMoodScore <= 30) {
          generalMood = require('../assets/emojis/Sad.png')
          quotes=[
            "Blijf vechten, ook als het moeilijk wordt. \nPijn is tijdelijk, maar opgeven is voor altijd.",
           " Niemand is perfect, en dat is oké.\nFocus op het omarmen van je imperfecties en het werken aan persoonlijke groei.",
           "Je voelt je niet zo goed in dit organisatie. \nJezelf aanpassen aan de omgeving is niet altijd even makkelijk, maar aarzel zeker niet om in geval van problemen te spreken met een collega of je werkgever"
          ]
        } else if (this.state.averageMoodScore > 30 && this.state.averageMoodScore < 50) {
          generalMood = require('../assets/emojis/Surprised.png')
          quotes = [
            "Je hoeft niet geweldig te zijn om te beginnen, maar je moet beginnen om geweldig te zijn.",
            "Het leven is niet altijd gemakkelijk, maar het is de manier waarop we omgaan met uitdagingen die ons vormt en ons sterker maakt.",
            "Hoe je je vandaag voelt, hoeft niet je morgen te bepalen. Blijf gemotiveerd en zet kleine stappen om je gemoedstoestand te verbeteren."
          ]
        } else if(this.state.averageMoodScore == 50){
          generalMood = require('../assets/emojis/Neutral.png')
          quotes = [
            "Je bent elke dag een stap dichterbij, dus geef vandaag niet op.",
            "Jouw mentale gezondheid is net zo belangrijk als jouw fysieke gezondheid.\nBesteed er net zoveel aandacht aan.",
            "Blijf gefocust op je doelen en vergeet niet te genieten van de reis."
          ]
        } else if(this.state.averageMoodScore > 50 && this.state.averageMoodScore <= 70){
          generalMood = require('../assets/emojis/OK.png')
          quotes = [
            "Makkelijker wordt het nooit, je wordt gewoon beter.",
            "Zelfzorg is geen egoïsme.\nAls je goed voor jezelf zorgt, ben je beter in staat om goed voor anderen te zorgen."
          ]
        } else if(this.state.averageMoodScore > 70 && this.state.averageMoodScore < 90){
          generalMood = require('../assets/emojis/Good.png')
          quotes = [
            "Een winnaar is een dromer die nooit opgeeft.",
            "Verandering is nooit gemakkelijk, maar soms is het nodig om te groeien.\nWees niet bang om nieuwe stappen te zetten en nieuwe dingen te proberen."
          ]
        } else if(this.state.averageMoodScore >= 90){
          generalMood = require('../assets/emojis/InLove.png')
          quotes = [
            "Kampioenen geloven in zichzelf, zelfs als niemand anders dat doet.",
            "Je bent niet alleen in je strijd. Wees niet bang om hulp te zoeken en steun te vragen wanneer je het nodig hebt."
          ]
        } else{
          generalMood = require('../assets/emojis/Neutral.png')
          quotes = [
            "Je bent elke dag een stap dichterbij, dus geef vandaag niet op.",
            "Jouw mentale gezondheid is net zo belangrijk als jouw fysieke gezondheid.\nBesteed er net zoveel aandacht aan."
          ]
        }
      level4 = 
      <IonCard className={styles.moodOverview}>
        <h1>Algemene mood</h1>
        <div className={(styles.graph)} style={{ width: 200, height: 200 }}>
          <CircularProgressbarWithChildren 
            value={this.state.averageMoodScore}
            styles={buildStyles({
            pathColor: `${moodScoreColor}`,
            strokeLinecap: 'round',
            pathTransition: 'stroke-dashoffset 0.5s ease 0s',
            rotation: 0.5,
            })}>
            <img src={generalMood} alt="algemene mood" className={(styles.generalMood)}/>
          </CircularProgressbarWithChildren>
            </div>

            <div>
              <h3>commentaar / motiverend zinnetje</h3>
              <p className = {styles.quote}>{quotes[(Math.floor(Math.random() * quotes.length))]}</p>
            </div>
      </IonCard>


      let level5;
      if (this.state.level >= 5) {

        let most = 
        <div className = {(styles.emojis)}>
        {this.state.mostEmoji.map(emoji =>
        <img
        key = {emoji}
        className = {(styles.emoji)}
        src={require(`../assets/emojis/${emoji}.png`)}/>
        )}
      </div>

        let least = 
        <div className = {(styles.emojis)}>
        {this.state.leastEmoji.map(emoji =>
        <img
        key = {emoji}
        className = {(styles.emoji)}
        src={require(`../assets/emojis/${emoji}.png`)}/>
        )}
      </div>

      level5=
      <IonCard className={(styles.moodOverview)}>
          <h1>Meest/minst voorkomende emoji</h1>
        <p className={(styles.title)}>Meest voorkomende emoji('s)</p>
          {most}
        <p className={(styles.title)}>Minst voorkomende emoji('s)</p>
          {least}
      </IonCard>
      } else {
        level5=
        <IonCard className={`${styles.moodOverview} ${styles.disabled}`}>
        <h1>Meest/minst voorkomende emoji</h1>
          <p className={styles.text}>Om het meest en minst voorkomende emoji te kunnen zien, moet je minstens level 5 zijn</p>
        </IonCard>
      }


      let level6;
      if(this.state.level >= 6) {
        let top = 
        <div className = {(styles.emojis)}>
        {this.state.top3emojis.map(emoji =>
        <img
        key = {emoji}
        className = {(styles.emoji)}
        src={require(`../assets/emojis/${emoji}.png`)}/>
        )}
      </div>

        let bottom = 
        <div className = {(styles.emojis)}>
        {this.state.bottom3emojis.map(emoji =>
        <img
        key = {emoji}
        className = {(styles.emoji)}
        src={require(`../assets/emojis/${emoji}.png`)}/>
        )}
      </div>

      level6 =
      <IonCard className={(styles.moodOverview)}>
        <h1>Top 3</h1>
        <p className={(styles.title)}>Meest gebruikte emoji's</p>
          {top}
        <p className={(styles.title)}>Minst gebruikte emoji's</p>
          {bottom}
      </IonCard>

    } else {
      level6 = 
      <IonCard className={`${styles.moodOverview} ${styles.disabled}`}>
        <h1>Top 3 <br/> Meest/minst gebruikte emoji's</h1>
        <p className={styles.text}>Om je top 3 emoji's te kunnen zien, moet je minstens level 6 zijn</p>
      </IonCard>
    }
    
    
    let level7;
    if(this.state.level >= 7) {
      level7=
      <IonCard className={styles.moodOverview}>
        <h1>Gedetailleerd mood overzicht</h1>
        <div className = {styles.chart}>
          <canvas  id="barChartMoods" ref={this.chartRef}></canvas>
        </div>
      </IonCard>
    } else{
      level7 = 
      <IonCard className={`${styles.moodOverview} ${styles.disabled}`}>
        <h1>Gedetailleerd mood overzicht</h1>
        <p className={styles.text}>Om een gedetailleerd overzicht te kunnen zien, moet je minstens level 7 zijn</p>
      </IonCard>
    }
    
    
    let level8;
    if(this.state.level >= 8) {
      let moods = this.state.moodPerSubject.slice(1).map((subject) => (
        <div key= {subject.id} className = {styles.flex}>
          <p className = {styles.subjectName}>{subject.name}</p>
          <div className= {styles.moodScore}>
            <div style={{width: `${subject.moodScore}%`, background: `${subject.moodColor}`}}>
              <img className = {styles.subjectMood} src={require(`../assets/emojis/${subject.emoji}.png`)} alt=""/>
            </div>
          </div>
        </div>
      ))

      level8=
      <IonCard className={styles.moodOverview}>
        <h1>Algemene mood per onderwerp</h1>
        <div className = {styles.moodPerSubject}>
        {moods}
        </div>
      </IonCard>
    } else{
      level8 = 
      <IonCard className={`${styles.moodOverview} ${styles.disabled}`}>
        <h1>Algemene mood per onderwerp</h1>
        <p className={styles.text}>Om je mood per onderwerp te kunnen zien, moet je minstens level 8 zijn</p>
      </IonCard>
    }
    
    
    let level9;
    if(this.state.level >= 9) {
      let userGrowth;
      if(this.state.lastChallengeScore > this.state.firstChallengeScore){
        userGrowth = 
        <div className = {styles.evolution}>
          <p>Ten opzichte van je eerste keer ben je in score <span style={{color: "#2dd36f"}}>gegroeid</span>.</p>
          <img src={require("../assets/icons/evolutionUp.png")} alt=""/>
          <p>Het is leuk te zien dat je je goed voelt in dit organisatie</p>
        </div>
      } else if(this.state.lastChallengeScore < this.state.firstChallengeScore){
        userGrowth = 
        <div className={styles.evolution}>
          <p>Ten opzichte van je eerste keer ben je in score <span style={{color: "#FF0000"}}>gedaald</span>.</p>
          <img src={require("../assets/icons/evolutionDown.png")} alt=""/>
          <p>Ondervind je hier vaak problemen? <br/> Aarzel niet om even te spreken met een collega of je werkgever</p>
        </div>
      }

      level9=
      <IonCard className={styles.moodOverview}>
        <h1>Emotionele evolutie</h1>
        {userGrowth}
      </IonCard>
    } else{
      level9 = 
      <IonCard className={`${styles.moodOverview} ${styles.disabled}`}>
        <h1>Emotionele evolutie</h1>
        <p className={styles.text}>Om je evolutie te kunnen zien, moet je minstens level 9 zijn</p>
      </IonCard>
    }
    
    
    let level10;
    if(this.state.level >= 10) {
      level10=
      <IonCard className={styles.moodOverview}>
        <h1>Grafiek evolutie</h1>
        <div className= {styles.lineChart}>
          <div className = {styles.chart} style={{position: "relative", width:"100vw"}}>
            <canvas  id="evolutionChart" ref={this.chartRef}></canvas>
          </div>
        </div>
      </IonCard>
    } else{
      level10 = 
      <IonCard className={`${styles.moodOverview} ${styles.disabled}`}>
        <h1>Emotionele evolutie - grafiek</h1>
        <p className={styles.text}>Om je evolutie in grafiekvorm te kunnen zien, moet je minstens level 10 zijn</p>
      </IonCard>
    }



        return(
            <IonPage>
                <IonHeader class="ion-no-border">
                    <IonToolbar>
                        <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
                        <IonTitle>Mood overzicht</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen >
                <div className={styles.overview}>
                  {level4}
                  {level5}
                  {level6}
                  {level7}
                  {level8}
                  {level9}
                  {level10}
                </div>
                </IonContent>
            </IonPage>
        );
    }
};

export default withRouter(MoodOverviewAll);
